import { trans } from "./../helper/trans";
import { humanDate } from "./../helper/humanDate";
import { notify } from "./../helper/notify";
import { buildFilter } from "./../helper/buildFilter";
import { adminPanel } from "../helper/adminPanel";
import { fetchNews } from "../helper/fetchNews";
import { fetchItems } from "../helper/fetchItems";
import { scroll } from "../helper/scroll";
import { buildReleaseEditor, toggleUpdate, releaseButton, newsButton } from "./../helper/buildReleaseEditor";
import { languages, sort, searchTerms, searchYear, searchTag, searchDark, lang } from "../app";
// some imports from our global scope
let resultsContainer = $("#search_wrapper"),
	termsError = false,
	news = [],
	tags = {},
	userLevel = "",
	author = "",
	pageNo = 1;
const searchBtn = $("submit_button button");

window.renderContent = async user => {
	userLevel = user.userLevel;
	const admin = userLevel.toLowerCase() === "admin";
	author = `${user.gacUser.firstname} ${user.gacUser.lastname}`;
	let params = {
		reqId: admin ? "60c30c77-a71a-4c4d-9ae6-3a73143c4a5e" : "133c4c69-6f3c-41f8-a982-f811db34fba8",
		// newsroomSearchQueryPvt/Public: return id, pubTimes of indexed releases;
		// the public request does not return pre-published or inactive releases

		type: "release",
		returnProps: "id, pubTime"
	};
	if (!admin) {
		params.now = new Date().getTime();
	}
	if (searchTerms || searchYear || searchTag || searchDark) {
		if (searchTerms) {
			let termValues = {};
			let termsFilter = searchTerms
				.map((term, index) => {
					termValues[`:t${index + 1}`] = term.toLowerCase();
					return `contains (#text, ${`:t${index + 1}`})`;
				})
				.join(" AND ");
			params.filterAdd = params.filterAdd ? `${params.filterAdd} AND ${termsFilter}` : ` AND ${termsFilter}`;
			params.valuesAdd = Object.assign(params.valuesAdd ? params.valuesAdd : {}, termValues);
			params.namesAdd = params.namesAdd
				? Object.assign(params.namesAdd, {
						"#text": "text"
				  })
				: { "#text": "text" };
		}
		if (searchYear) {
			let nowYear = new Date().getFullYear();
			let start = new Date(`${searchYear}/1/1`).getTime();
			let end = searchYear >= nowYear ? new Date().getTime() : new Date(`${searchYear}/12/31 23:59:59`).getTime();
			params.valuesAdd = Object.assign(params.valuesAdd ? params.valuesAdd : {}, {
				":start": start,
				":end": end
			});
			if (admin) {
				// pubTime attribute is built in to the public request,
				// but not the admin request, so we need to add it here

				params.namesAdd = Object.assign(params.namesAdd ? params.namesAdd : {}, {
					"#pubTime": "pubTime"
				});
			}
			params.filterAdd = params.filterAdd ? `${params.filterAdd} AND #pubTime BETWEEN :start AND :end` : " AND #pubTime BETWEEN :start AND :end";
		}
		if (searchTag) {
			let tagArr = searchTag.split(",");
			let tagValues = {};
			let tagFilter = `${tagArr
				.map((tag, index) => {
					tagValues[`:searchTag${index}`] = tag;
					return `contains (#tags, :searchTag${index})`;
				})
				.join(" AND ")}`;
			// map tag values into a filter expression extender
			// and ExpressionAttributeValues object

			params.namesAdd = Object.assign(params.namesAdd ? params.namesAdd : {}, {
				"#tags": "tags"
			});
			params.valuesAdd = Object.assign(params.valuesAdd ? params.valuesAdd : {}, tagValues);
			params.filterAdd = params.filterAdd ? `${params.filterAdd} AND ${tagFilter}` : ` AND ${tagFilter}`;
		}
		if (searchDark) {
			params.namesAdd = Object.assign(params.namesAdd ? params.namesAdd : {}, {
				"#darkpage": "darkpage"
			});
			if (admin) {
				params.valuesAdd = Object.assign(params.valuesAdd ? params.valuesAdd : {}, {
					":true": true
				});
			}
			params.filterAdd = params.filterAdd ? `${params.filterAdd} AND #darkpage = :true` : " AND #darkpage = :true";
		}
		// set params

		try {
			let response = await fetchNews(
				{
					container: $("#search_wrapper"),
					size: 1
				},
				[],
				null,
				params,
				userLevel
			);
			searchRouter(response, userLevel);
		} catch (err) {
			console.error("Error fetching search results");
			if (err) {
				console.error(err);
			}
			termsError = trans("error");
		}
	} else {
		termsError = trans("No search information was provided.");
		presentResults("desc", userLevel);
	}
};
// end renderContent function

const searchRouter = async (matches, userLevel) => {
	news = matches.data.sort((a, b) => {
		if (a.pubTime > b.pubTime) {
			return sort === "asc" ? 1 : -1;
		} else if (a.pubTime < b.pubTime) {
			return sort === "asc" ? -1 : 1;
		}
		return 0;
	});
	presentResults(sort, userLevel);
};

const presentResults = async (sort = "desc", userLevel) => {
	// this is where news releases are listed

	let admin = userLevel === "admin";
	resultsContainer.html(`<div id="admin_controls"></div>
        <div id="editor_wrapper"></div>
        <div id="release_header" class="page-heading uk-heading-small uk-text-center">${trans("Search Results")}</div>
        <div id="filter_wrapper"></div>
        <div id="showing_wrapper"></div>
        <div class="uk-margin-remove" id="list_wrapper"></div>
        <div id="pagination_wrapper" class="uk-margin-large-top">
            <ul class="uk-pagination uk-flex uk-flex-center uk-flex-middle">
            </ul>
        </div>`);
	buildFilter(tags, $("#filter_wrapper"), userLevel);

	let listWrapper = $("#list_wrapper");
	if (news.length) {
		let showingWrapper = $("#showing_wrapper");
		let paginationWrapper = $("#pagination_wrapper");
		let pageList = paginationWrapper.find("ul");
		let perPage = 10;
		let numPages = Math.ceil(news.length / perPage);
		let scrollTarget = $("#release_header");

		/* set up pagination */
		const updatePagination = () => {
			pageList.html("");
			if (pageNo > 1) {
				pageList.append(`<li>
                <a data-previous data-target="${pageNo - 1}"><span uk-pagination-previous></span></a>
            </li>`);
			}
			// we need a previous button if we're past page 1

			let isActive = pageNo === 1;
			pageList.append(`<li>
            <a data-target="1" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">1</span></a>
        </li>`);
			// always have page 1

			if (numPages < 11) {
				// don't need our inactive elements
				for (let i = 2; i < numPages + 1; i++) {
					isActive = pageNo === i;
					pageList.append(`<li>
                    <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
				}
			} else {
				// need at least one inactive separator
				if (pageNo < 6) {
					// don't need beginning separator
					for (let i = 2; i < 9; i++) {
						isActive = pageNo === i;
						pageList.append(`<li>
                    <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
					}
					pageList.append(` <li class="uk-disabled"><span>...</span></li>
                <li>
                    <a data-target="${numPages}" class="page_link"${pageNo === numPages ? " uk-active" : ""}"><span class="page${pageNo === numPages ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
				} else {
					// need at least beginning separator
					pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
					let remaining = numPages - pageNo;
					let lastPage = remaining > 2 ? pageNo + 3 : numPages;
					for (let i = pageNo - 2; i < lastPage; i++) {
						isActive = pageNo === i;
						pageList.append(`<li>
                        <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                    </li>`);
					}
					if (pageNo < numPages - 3) {
						// need second separator
						pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
					}
					pageList.append(`<li>
                    <a data-target="${numPages}" class="page_link${pageNo === numPages ? " uk-active" : ""}"><span class="page${pageNo === numPages ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
				}
			}
			if (pageNo < numPages) {
				pageList.append(`<li>
                <a data-next data-target="${pageNo + 1}"><span uk-pagination-next></span></a>
            </li>`);
			}
			// we need a next button if we're not on last page

			let startPage = pageNo * perPage - perPage + 1;
			let endPage = pageNo * 10 > news.length ? news.length : pageNo * 10;
			// calculate last page in showing range

			showingWrapper.html(`<span>${trans("showing") ? trans("showing") : "Showing"}</span> ${startPage} - ${endPage} ${trans("of") ? trans("of") : "of"} ${news.length}`);

			$("#pagination_wrapper [data-target]").on("click", async function () {
				pageNo = parseInt($(this).attr("data-target"));
				const targets = $(`.release_wrapper[data-page="${pageNo}"]`);
				if (targets.length) {
					$(".release_wrapper")
						.not(`[data-page="${[pageNo]}"]`)
						.hide();
					targets.show();
					scroll(scrollTarget, 0, 500);
					updatePagination();
				}
			});
			// click handler for pagination
		};
		// end updatePagination function

		updatePagination();
		const admin = userLevel === "admin";
		let startIndex = 0;
		let pages = [];
		while (news.slice(startIndex, startIndex + perPage).length) {
			// there's data beyond current startIndex
			pages.push(news.slice(startIndex, startIndex + perPage));
			startIndex = startIndex + perPage;
		}
		for (let i = 0; i < pages.length; i++) {
			const relPage = i + 1;
			try {
				const response = await fetchItems(pages[i], "release", searchBtn, admin);
				let releases = response.sort((a, b) => {
					a = a.langs[lang].pubTime;
					b = b.langs[lang].pubTime;
					return a < b ? 1 : a > b ? -1 : 0;
				});
				releases.forEach((release, relIndex) => {
					let aPanel;
					let values;
					pages[i][relIndex] = release;
					if (admin) {
						// only build aPanel if release is fetched
						aPanel = adminPanel(release);
					}
					// admins get control panel data

					values = release.langs && release.langs[lang] ? release.langs[lang] : "";
					// for public user, we only want the values matching the selected language

					let releaseWrapper = `<div data-page="${relPage}" data-id="${release.id}" class="release_wrapper uk-padding-large uk-padding-remove-horizontal" ${pageNo === relPage ? "" : `style="display: none;"`}>
			${
				release.relId
					? ""
					: `<div class="content_wrapper" uk-grid>
		                <div class="uk-width-1-1 uk-width-1-3@s">
		                    <span class="pubDate heading bold">${humanDate(values.pubTime)}</span>
		                    ${
								admin
									? `<div class="metadata_wrapper">
		                        <div class="metadata_row">
		                            <span class="lang_wrapper">${aPanel.langs}</span>
		                        </div>
		                        <div class="metadata_row">
		                            <span class="metadata_label">Publish date past?</span> <span class="pubbed_wrapper">${aPanel.pubbed}</span>
		                        </div>
								 <div class="metadata_row">
		                            <span class="metadata_label">Created/updated by:</span> <span class="editors_wrapper">${aPanel.editors}</span>
		                        </div>
		                        <div class="metadata_row">
		                            <span class="metadata_label">News feed?</span> <span class="feed_wrapper">${aPanel.feed}</span>
		                        </div>
								<div class="metadata_row">
		                            <span class="metadata_label">Sustainability feed?</span> <span class="sust_feed_wrapper">${aPanel["sust-feed"]}</span>
		                        </div>
		                        <div class="metadata_row">
		                            <span class="metadata_label">Featured?</span> <span class="featured_wrapper">${aPanel.featured}</span>
		                        </div>
		                        <div class="metadata_row">
		                            <span class="metadata_label">Active?</span> <span class="status_wrapper">${aPanel.status}</span>
		                        </div>
		                         <div class="metadata_row">
		                            <span class="metadata_label">"Dark" item?</span> <span class="status_wrapper">${aPanel.darkpage}</span>
		                        </div>
		                        <div class="metadata_row">
		                            <span class="metadata_label">Tags:</span> <span class="tags_wrapper">${aPanel.releaseTags}</span>
		                            </div>
		                    </div>`
									: ""
							}
		                </div>
		                <div class="uk-width-1-1 uk-width-2-3@s uk-margin-remove">
							${admin ? `<div class="uk-text-small">ID: ${release.id}</div>` : ""}
		                    <div class="heading catLinks">${values && values.tags && values.tags.length ? `Categories: ${values.tags.map(tag => `<a href="/${lang}/search/?tag=${tag}">${tag}</a>`).join(", ")}` : ""}</div>
		                    <div class="headline heading">${values ? `<a href="/${lang}/news/?id=${release.id}">${values.headline}</a>` : ""}</div>
		                    <div class="summary">${values ? values.summary : ""}</div>
		                    <div class="read_more_link">
		                        ${values ? `<a href="/${lang}/news/?id=${release.id}">${trans("Read News Release")}</a></span>${admin ? `<span data-button="edit button" class="edit_link"  uk-icon="icon: pencil; ratio: 1.2"></span>` : ""}` : ""}
		                    </div>
		                </div>    
		            </div>`
			}
		    </div>`;
					// for admins, add pub date AND time, status, languages and tags;

					listWrapper.append(releaseWrapper);
				});
			} catch (err) {
				console.error(err);
			}
		}
		news = pages.flat();
		if (admin) {
			$("[data-button='edit button']").on("click", function () {
				buildReleaseEditor(news, tags, $(this).parents(".release_wrapper").attr("data-id"), lang, author, userLevel, searchRouter);
				// open news editor with this release
			});
			// edit button click handler

			$("[data-more]").on("click", function (e) {
				e.preventDefault();
				const type = $(this).attr("data-type");
				switch (type) {
					case "pubbed":
						notify(`${languages[$(this).attr("data-lang")]} publish time: ${$(this).attr("data-more")}`, "primary", "top-right", 3000, "metadata", true);
						break;

					case "tags":
						notify(`${languages[$(this).attr("data-lang")]} tags: ${$(this).attr("data-more")}`, "primary", "top-right", 3000, "metadata", true);
						break;

					case "editors":
						const editData = $(this).attr("data-more").split(",");
						const lang = languages[$(this).attr("data-lang")];
						notify(`<div style="text-align: left !important;">${lang} creator:<br/>${editData[0]} (${humanDate(parseInt(editData[1]))})<br/><br/>Last ${lang} editor:<br/>${editData[2]} (${humanDate(parseInt(editData[3]))})</div>`, "primary", "top-right", 3000, "metadata", true);
						break;
				}

				// notify with additional data requested
			});

			$(".feed_wrapper, .sust_feed_wrapper, .featured_wrapper, .status_wrapper")
				.find("[data-toggle]")
				.on("click", function () {
					toggleUpdate($(this), news)
						.then(() => {
							presentResults("desc", userLevel);
						})
						.catch(err => {
							console.error(err);
							notify(err, "danger", "top-right", 3000, null, true);
						});
				});
			// for toggled metadata (news feed, featured, status), update with a click
		}
		// event handling for admins in metadata panel
	}
	// there are results to show
	else {
		listWrapper.html(`<div>${trans("There were no results.")}${termsError ? ` ${termsError}` : ""}</div>`);
	}
	if (admin && !$("[data-button='create news release']").length) {
		$("#admin_controls").append(newsButton);
	}
	//  if this is an admin and there is no "create news
	// release" button already, add it

	releaseButton("create", news, tags, searchRouter, author, userLevel, newsButton, null, buildReleaseEditor);
	// instantiate click handler
};
// end presentResults function
